import { CustomActions } from "@bToC/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<
    {
        quoteNumber: string;
        onUnauthenticated?: () => void;
        onBeginDownload?: () => void;
        onSuccess?: () => void;
        onError?: () => void;
    },
    DispatchProp<CustomActions>
>;

export const DownloadQuote: HandlerType = props => {
    if (!props.getState().context.session?.isAuthenticated) {
        props.parameter.onUnauthenticated?.();
        return false;
    }

    const apiUrl = `${window.origin}/api/v1/GerrieQuote/pdf?quoteNumber=${props.parameter.quoteNumber}`;

    props.parameter.onBeginDownload?.();

    fetch(apiUrl, {
        method: "GET",
    }).then((response: Response) => {
        if (response.status === 200) {
            response.blob().then(blob => {
                if (blob.size > 25) {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.target = "_blank";
                    link.click();
                } else {
                    props.parameter.onError?.();
                }
            });
        } else {
            props.parameter.onError?.();
        }
    });

    props.parameter.onSuccess?.();
};

export const chain = [DownloadQuote];

const downloadQuote = createHandlerChainRunner(chain, "DownloadQuote");
export default downloadQuote;
